<footer class="app-footer">
  <div class="container">
    <div class="row content-center">
      <div class="col">
        <div *ngIf="checkLogIn()">
          <small><i class="fas fa-user"></i>{{'     ' + user.data.user.nome.toLowerCase()}}</small>
        </div>
      </div>
      <div class="col">
        <small>{{'Provided by - www.az.eti.br'}} </small>
      </div>
    </div>
  </div>
</footer>